<!-- 创建时间2023/06/15 14:12:02 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：随机封面 -->
<template>
  <yxt-drawer :title="$t('pc_kng_upload_tit_choose5'/** 选择系统封面 */)" size="960px" :visible.sync="visible">
    <div class="yxtbiz-system-image">
      <img
        :class="item === url ? 'border-primary-6 yxtbiz-system-image--selected' : ''"
        v-for="item in list"
        :key="item"
        :src="item"
        alt=""
        @click="select(item)"
      />
    </div>
    <div slot="footer">
      <yxt-button plain @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
      <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import { getSystemCoverImages } from '../../../utils';

export default {
  name: 'radom-cover-drawer',
  data() {
    return {
      visible: false,
      list: getSystemCoverImages(true),
      url: ''
    };
  },
  methods: {
    init() {
      return new Promise((resolve, reject) => {
        this.url = '';
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    getRandom() {
      return getSystemCoverImages(false);
    },
    select(url) {
      this.url = url;
    },
    confirm() {
      this.visible = false;
      this.resolve(this.url);
    },
    cancel() {
      this.visible = false;
      this.reject(new Error('cancel'));
    }
  }
};
</script>